import { TopPage } from "@/components/elements/TopPage";
import { companyMenu } from "@/features/company/constants/companyMenu";
import { TCompanyMenu } from "@/features/company/types/companyMenu";
import { getDynamicRoute } from "@/utils/url";
import { Stack, styled } from "@mui/material";
import { FC } from "react";
import { Link, matchRoutes, Outlet, useLocation, useParams } from "react-router-dom";

type TCompanyLayoutProps = {};

export const CompanyLayout: FC<TCompanyLayoutProps> = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const renderRoutes = (menu: TCompanyMenu[]) => {
    return menu.map(({ title, url, extraUrls }) => {
      const isActive =
        matchRoutes([{ path: url }], pathname) !== null || extraUrls?.some((extraUrl) => matchRoutes([{ path: extraUrl }], pathname) !== null);

      return (
        <StyledLink isActive={isActive} key={url} className={isActive ? "active" : ""} to={getDynamicRoute(url, { id })}>
          {title}
        </StyledLink>
      );
    });
  };

  return (
    <Stack gap={2.5}>
      <TopPage title="受け入れ企業の一覧" enablePageBack={false} />
      <Stack direction="row" gap={5}>
        {renderRoutes(companyMenu)}
      </Stack>
      <Outlet />
    </Stack>
  );
};

const options = { shouldForwardProp: (propName: string) => !["isActive"].includes(propName) };

const StyledLink = styled(
  Link,
  options,
)<{ isActive: boolean }>(({ isActive }) => ({
  textDecoration: isActive ? "underline" : "none",
}));
